<template>
  <el-table
    ref="sharedTable"
    v-loading="loading"
    class="mt-xl"
    header-row-class-name="table-header"
    :data="data"
    size="medium"
    border
    stripe
    @selection-change="selectionChange"
  >
    <el-table-column
      type="selection"
      width="50"
      align="center"
    />
    <el-table-column
      prop="stt"
      label="STT"
      align="center"
      width="80"
    >
      <template slot-scope="scope">
        {{ scope.row.stt }}
      </template>
    </el-table-column>
    <el-table-column
      prop="avartar"
      label=""
      align="center"
      width="80"
    >
      <template slot-scope="scope">
        <ImageDefault
          :src="scope.row.extra.file_images | avatarUrl(avatarData)"
          width="48px"
          height="48px"
        />
      </template>
    </el-table-column>
    <el-table-column
      v-for="(c, index) in columns"
      :key="index"
      :prop="c.key"
      :label="c.label"
      :align="c.column.align"
      :width="c.column.width"
      :min-width="c.column.min_width || '100px'"
    >
      <template slot-scope="scope">
        <ViewItem
          :field="c"
          :data="scope.row"
        />
      </template>
    </el-table-column>
    <el-table-column
      prop="packages"
      label="Giá"
      align="center"
      width="80"
      fixed="right"
    >
      <template slot-scope="scope">
        <el-button
          icon="el-icon-money"
          type="primary"
          size="medium"
          circle
          @click="$emit('package', scope.row)"
        />
      </template>
    </el-table-column>
    <el-table-column
      v-if="columnActions.length > 0"
      label="Thao tác"
      width="160"
      fixed="right"
      align="center"
    >
      <template slot-scope="scope">
        <Buttons
          :item="scope.row"
          :buttons="columnActions"
          @detail="(v) => $emit('view', v)"
          @edit="(v) => $emit('edit', v)"
          @tag="(v) => $emit('tag', v)"
          @delete="(v) => $emit('delete', v)"
          @connection="(v) => $emit('connection', v)"
        />
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import Buttons from "@/components/items/Buttons.vue";
import ImageDefault from "@/components/items/ImageDefault.vue";
import ViewItem from "@/components/items/ViewItem.vue";
import constants from "@/config/constants";

export default {
  name: "CardList",
  components: {
    Buttons,
    ImageDefault,
    ViewItem,
  },
  props: {
    config: Object,
    data: Array,
    approvedData: Array,
    avatarData: Array,
    loading: Boolean,
    permission: Object,
    tagPermission: Object,
  },
  data() {
    return {
      fieldType: constants.FIELD_TYPE,
    };
  },
  computed: {
    columnActions() {
      const actions = this.config.extra.column_actions || [];
      return actions.filter((a) => {
        if (a === "connection") {
          return this.config.extra?.relations?.length > 0;
        }
        if (a === "delete") {
          return this.permission.DELETE
        }
        if (a === "tag") {
          return this.permission.UPDATE && this.tagPermission.READ
        }
        return true;
      });
    },
    columns() {
      const result = this.config.extra.fields;
      return result
        .filter((i) => i.show.column)
        .sort((a, b) => a.order - b.order);
    },
  },
  methods: {
    selectionChange(v) {
      this.$emit('select', v)
    }
  },
};
</script>

<style lang="scss"></style>
